import { render, staticRenderFns } from "./UsersCreate.vue?vue&type=template&id=31952f92&"
import script from "./UsersCreate.vue?vue&type=script&lang=js&"
export * from "./UsersCreate.vue?vue&type=script&lang=js&"
import style0 from "./UsersCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports